export const faqs = [
  {
    question: '六角琴适合零基础的成年人学习吗？',
    answer: '非常合适。六角琴的音阶排列直观，入门门槛相对较低。成年人理解能力强，只要坚持练习，三个月内即可弹奏简单曲目。建议从基本指法和音阶练习开始，配合我们入门教程中的视频指导，学习效果更佳。',
  },
  {
    question: '初学者应该选择什么价位的六角琴？',
    answer: '建议入门选择 1500-4000 元区间的六角琴。这个价位的乐器工艺成熟，音色稳定，足以满足初学阶段的需求。不建议购买过于廉价的乐器（低于800元），这类产品往往音准不佳、手感粗糙，会影响学习兴趣和进度。',
  },
  {
    question: '六角琴需要定期调音吗？多久调一次？',
    answer: '是的，六角琴需要定期调音。新琴在前三个月由于琴弦张力逐渐稳定，建议每周调音一次；三个月后可以延长至每两周一次。如果经常演奏或环境温湿度变化较大，建议增加调音频率。长期不调音会影响音准感和演奏效果。',
  },
  {
    question: '六角琴和扬琴有什么区别？',
    answer: '六角琴与扬琴虽然同属打击弦鸣乐器，但有显著区别。六角琴琴体为六边形结构，琴弦排列方式独特，音色更为清脆明亮；而扬琴通常为梯形结构，音域更广，音色较为圆润。六角琴在民间音乐和特定地域文化中有着不可替代的地位。',
  },
  {
    question: '六角琴有哪些知名品牌推荐？',
    answer: '国内知名品牌包括敦煌、乐海、星海等传统乐器制造商，它们拥有数十年的制作经验和成熟工艺。此外也有不少独立制琴师工作室，如「清音坊」「雅乐堂」等，以手工精制著称。具体选择可参考我们的品牌对比专栏文章。',
  },
  {
    question: '六角琴的琴弦多久需要更换一次？',
    answer: '正常情况下，六角琴琴弦建议每 6-12 个月更换一次。如果演奏频繁（每天超过2小时），建议 4-6 个月更换。琴弦老化后会出现音色发闷、音准不稳定等问题。更换琴弦时建议整套更换，以保证音色统一。',
  },
  {
    question: '儿童几岁可以开始学习六角琴？',
    answer: '建议 7-8 岁以上的儿童开始学习六角琴。这个年龄段的孩子手部肌肉发育较为成熟，能够适应琴槌的握持和击弦动作。对于年龄较小的孩子（5-6岁），可以先进行音乐启蒙和节奏训练，为日后学习打基础。',
  },
  {
    question: '六角琴可以自学吗？需要找老师吗？',
    answer: '成人完全可以通过在线教程和教材自学六角琴，初学者先掌握基本演奏姿势和简单曲目即可。但如果想要系统学习、纠正不良习惯，建议在入门阶段请专业老师指导 3-6 个月，打好基础后再自行练习会更高效。',
  },
];